import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";
import { useRef } from "react";
import { addNewConcept, getAllConcepts, getAllTrainers } from "../../api";
import { BsGithub, BsGlobe, FaVideo, FaYoutube } from "../../assets/icons";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { buttonClick } from "../../utils/animations";
import { categories, languages } from "../../utils/supportFunctions";
import { DropMenu, InputField } from "../Others";
import ImageUploader from "./ImageUploader";

const NewConcept = () => {
  const [videoName, setVideoName] = useState("");
  const [imageDownloadUrl, setImageDownloadUrl] = useState(null);
  const [youtubeURL, setYoutubeURL] = useState("");
  const [github, setGithub] = useState("");
  const [liveURL, setLiveURL] = useState("");
  const [category, setCategory] = useState(null);
  const [lang, setLang] = useState("English");
  const [trainer, setTrainer] = useState(null);
  const effectRun = useRef();

  const [
    { allTrainers, alertState, alertType, allConcepts, mainLoader },
    dispatch,
  ] = useStateValue();

  useEffect(() => {
    // if (effectRun.current === true) {
    if (!allTrainers) {
      getAllTrainers().then((trainer) => {
        dispatch({
          type: actionType.SET_TRAINERS,
          allTrainers: trainer.data,
        });
      });
    }
    // }
    return () => {
      // effectRun.current = true;
    };
  }, []);

  const saveNewConcept = () => {
    const data = {
      video_name: videoName,
      video_thumb: imageDownloadUrl,
      videoURL: youtubeURL,
      github: github,
      liveURL: liveURL,
      category: category,
      lang: lang,
      trainer: trainer,
    };
    if (!videoName || !imageDownloadUrl || !youtubeURL) {
      dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "warning" });
      dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

      setTimeout(() => {
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
      }, 3000);
    } else {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });
      dispatch({ type: actionType.SET_ALERT_TYPE, alertType: "success" });
      dispatch({ type: actionType.SET_ALERT_STATE, alertState: true });

      addNewConcept(data).then((res) => {
        getAllConcepts().then((concept) => {
          dispatch({
            type: actionType.SET_CONCEPTS,
            allConcepts: concept.data,
          });
        });
      });
      setVideoName("");
      setImageDownloadUrl(null);
      setYoutubeURL("");
      setTrainer(null);
      setCategory(null);
      setLang("English");
      setLiveURL("");
      setGithub("");

      setTimeout(() => {
        dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
        dispatch({ type: actionType.SET_ALERT_STATE, alertState: false });
        dispatch({ type: actionType.SET_ALERT_TYPE, alertType: null });
      }, 3000);
    }
  };

  return (
    <div className=" w-full p-4 flex  items-center justify-center flex-1">
      <div className=" w-full sm:w-[750px] border border-gray-300 p-4 rounded-md flex flex-col gap-4 items-start justify-center">
        <InputField
          icon={<FaVideo className="-rotate-0" />}
          stateFunc={setVideoName}
          stateValue={videoName}
          name="Title Of the video"
        />

        <div className=" w-full flex items-center justify-between flex-wrap gap-2">
          {categories &&
            categories.map((n) => (
              <motion.div
                key={n.id}
                {...buttonClick}
                className={`px-2 py-1 rounded-md flex items-center justify-center border border-gray-300 hover:shadow-md cursor-pointer ${
                  category === n.categoryId
                    ? "bg-gray-200 shadow-md font-semibold"
                    : "shadow-none bg-transparent"
                }`}
                onClick={() => setCategory(n.categoryId)}
              >
                <p className="text-textColor text-sm"> {n.name}</p>
              </motion.div>
            ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 w-full gap-3">
          <div className=" w-full flex items-center justify-between flex-wrap gap-3  col-span-1">
            {languages &&
              languages.map((n) => (
                <motion.div
                  key={n.id}
                  {...buttonClick}
                  className={`px-2 py-1 rounded-md flex flex-1 items-center justify-center border border-gray-300 hover:shadow-md cursor-pointer ${
                    lang === n.name
                      ? "bg-gray-200 shadow-md font-semibold"
                      : "shadow-none bg-transparent"
                  }`}
                  onClick={() => setLang(n.name)}
                >
                  <p className="text-textColor text-sm"> {n.name}</p>
                </motion.div>
              ))}
          </div>

          <div className="col-span-2 flex items-center justify-center">
            <DropMenu
              data={allTrainers}
              stateValue={trainer}
              stateFunc={setTrainer}
              type="All Languages"
            />
          </div>
        </div>

        <ImageUploader
          setImageDownloadUrl={setImageDownloadUrl}
          imageDownloadUrl={imageDownloadUrl}
        />

        <InputField
          icon={<FaYoutube className="-rotate-0" />}
          stateFunc={setYoutubeURL}
          stateValue={youtubeURL}
          name="YouTube URL"
        />

        <InputField
          icon={<BsGithub className="-rotate-0" />}
          stateFunc={setGithub}
          stateValue={github}
          name="Github URL"
        />

        <InputField
          icon={<BsGlobe className="-rotate-0" />}
          stateFunc={setLiveURL}
          stateValue={liveURL}
          name="Project Live URL"
        />

        <div className="my-4 mb-12 w-full flex items-center justify-center">
          <motion.button
            {...buttonClick}
            className="px-8 py-2 w-full sm:w-300 hover:shadow-md hover:bg-emerald-500  rounded-md bg-emerald-400 text-lg uppercase font-semibold text-white"
            onClick={saveNewConcept}
          >
            Save
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default NewConcept;
